const checkFileExtention = (filename = '') => {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex !== -1) {
    const fileExtention = filename.slice(dotIndex + 1);

    const accessibleExtentions = [
      'csv',
      'xls',
      'xlsx',
    ];

    if (accessibleExtentions.includes(fileExtention)) return true;
  }

  return false;
};

const init = () => {
  const importPopup = document.querySelector('#import-popup');

  if (importPopup) {
    const popupBody = importPopup.querySelector('.popup__content');

    importPopup.addEventListener('dragover', (e) => {
      e.preventDefault();

      importPopup.classList.add('_dragover');
    });
    importPopup.addEventListener('dragleave', (e) => {
      e.preventDefault();

      if (!e?.fromElement?.classList.contains('popup__file-dropzone')
        && !e.target.closest('.popup__content')) importPopup.classList.remove('_dragover');
    });

    popupBody.addEventListener('drop', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();

      const isAccessible = checkFileExtention(evt.dataTransfer.files[0].name);

      if (isAccessible) {
        const fileInput = importPopup.querySelector('#cart-import-file');

        if (fileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(evt.dataTransfer.files[0]);
          fileInput.files = dataTransfer.files;

          const event = new Event('change');

          fileInput.dispatchEvent(event);
        }
      } else {
        const popupTitle = '<h2 class="popup__title">Ошибка</h2>';
        const popupDescription = 'Поддерживаются только файлы формата .csv, .xls, .xlsx';

        window.popupOpenUniversalForm(popupTitle, popupDescription);
      }

      window.popupClose(importPopup);
      setTimeout(() => {
        importPopup.classList.remove('_dragover');
      }, 200);
    });
  }
};

window.initImportPopupDropzone = init;
